import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import NhapXuatService from "services/sale/NhapXuatService";
import Utils from "utils";

export const getDSNhapXuat = createAsyncThunk(
  "nhapxuat/getDSNhapXuat",
  async (data, { rejectWithValue }) => {
    try {
      const response = await NhapXuatService.searchGrid(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const getNhapXuatByManx = createAsyncThunk(
  "nhapxuat/getNhapXuatByManx",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapXuatService.getNhapXuatByManx(payload);
      response.data.ngay = Utils.convertMomentToDate(response.data.ngay);
      if (response.data.ngayhoadon !== null) {
        response.data.ngayhoadon = Utils.convertMomentToDate(
          response.data.ngayhoadon
        );
      }
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const createNhapXuat = createAsyncThunk(
  "nhapxuat/createNhapXuat",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapXuatService.create(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateNhapXuat = createAsyncThunk(
  "nhapxuat/updateNhapXuat",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapXuatService.update(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const importHoadon = createAsyncThunk(
  "nhapxuat/importHoadon",
  async (data, { rejectWithValue }) => {
    try {
      const { formData, onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapXuatService.importHoadon(formData);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getHoadonChiTiet = createAsyncThunk(
  "nhapxuat/getHoadonChiTiet",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapXuatService.getHoadonChiTiet(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateHoadonChiTiet = createAsyncThunk(
  "nhapxuat/updateHoadonChiTiet",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapXuatService.updateHoadonChiTiet(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const chuyenHoaDonThanhPhieuNhap = createAsyncThunk(
  "nhapxuat/chuyenHoaDonThanhPhieuNhap",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapXuatService.chuyenHoaDonThanhPhieuNhap(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const copyPhieuNhapThueSangNoiBo = createAsyncThunk(
  "nhapxuat/copyPhieuNhapThueSangNoiBo",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapXuatService.copyPhieuNhapThueSangNoiBo(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const donViPhieuCuoiCungNhap = createAsyncThunk(
  "nhapxuat/donViPhieuCuoiCungNhap",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapXuatService.donViPhieuCuoiCungNhap(payload.loaiphieu);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const changeStateNhapXuat = createAsyncThunk(
  "nhapxuat/changeStateNhapXuat",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapXuatService.changeStateNhapXuat(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteNhapXuat = createAsyncThunk(
  "nhapxuat/deleteNhapXuat",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await NhapXuatService.deleteNhapXuat(id);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  nhapXuatList: [],
  nhapXuatDetail: {},
  importHoadonList: [],
  importHoadonDetailList: [],
};

export const nhapxuatSlice = createSlice({
  name: "nhapxuat",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setHisInfo: (state, action) => {
      state.hisInfoList = action.payload;
    },
    setNhapXuatDetail: (state, action) => {
      state.nhapXuatDetail = null;
    },
    setInvoiceNull: (state, action) => {
      state.importHoadonList = null;
      state.importHoadonDetailList = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(chuyenHoaDonThanhPhieuNhap.pending, (state) => {
        state.loading = true;
      })
      .addCase(chuyenHoaDonThanhPhieuNhap.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(chuyenHoaDonThanhPhieuNhap.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getHoadonChiTiet.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHoadonChiTiet.fulfilled, (state, action) => {
        state.loading = false;
        state.importHoadonDetailList = action.payload;
      })
      .addCase(getHoadonChiTiet.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(importHoadon.pending, (state) => {
        state.loading = true;
      })
      .addCase(importHoadon.fulfilled, (state, action) => {
        state.loading = false;
        state.importHoadonList = action.payload;
      })
      .addCase(importHoadon.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getDSNhapXuat.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDSNhapXuat.fulfilled, (state, action) => {
        state.loading = false;
        state.nhapXuatList = action.payload;
      })
      .addCase(getDSNhapXuat.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getNhapXuatByManx.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNhapXuatByManx.fulfilled, (state, action) => {
        state.loading = false;
        state.nhapXuatDetail = action.payload;
      })
      .addCase(getNhapXuatByManx.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createNhapXuat.pending, (state) => {
        state.loading = true;
      })
      .addCase(createNhapXuat.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createNhapXuat.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateNhapXuat.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateNhapXuat.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateNhapXuat.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setHisInfo, setNhapXuatDetail, setInvoiceNull } =
  nhapxuatSlice.actions;

export default nhapxuatSlice.reducer;
